import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AngularMaterialModule } from 'src/app/material.module';
import { BaseComponent } from '@lib/components';
import { ICustomer } from '@lib/interfaces';
import { ISenderInfo, ITransferToAgentRequest } from '@lib/interfaces/super-agent-transfer.interface';
import { SidePanelService } from '@lib/services';
import { currencyDecimals, formatPhoneNumber, maskFullName } from '@lib/utils';
import { EnterPasscodeComponent } from '../enter-passcode/enter-passcode.component';

@Component({
    selector: 'app-confirm-transfer',
    standalone: true,
    templateUrl: './confirm-transfer.component.html',
    styleUrls: ['./confirm-transfer.component.scss'],
    imports: [AngularMaterialModule],
})
export class ConfirmTransferComponent extends BaseComponent {
    recipientInfo: ICustomer;
    senderInfo: ISenderInfo;
    amount: number;
    currency: string;
    note?: string;

    constructor(private readonly dialogRef: MatDialogRef<ConfirmTransferComponent>, private readonly sidePanel: SidePanelService) {
        super();
    }

    protected get maskedRecipientName(): string {
        return maskFullName(this.recipientInfo.first_name, this.recipientInfo.last_name);
    }

    protected get formattedRecipientMobile(): string {
        return formatPhoneNumber(this.recipientInfo.mobile);
    }

    protected get formattedSenderMobile(): string {
        return formatPhoneNumber(this.senderInfo?.mobile);
    }

    protected get amountDecimals(): string {
        return currencyDecimals(this.currency);
    }

    // NEOIQ-2427: passcode is now always collected before transferToAgent is ever called — this
    // screen just hands off to EnterPasscodeComponent, which builds the full payload (including
    // `passcode`) and makes the single actual API call. No API call happens here anymore.
    protected confirmTransfer(): void {
        const payload: ITransferToAgentRequest = {
            mobile_number: this.recipientInfo.mobile,
            amount: this.amount,
            currency: this.currency,
            note: this.note,
        };

        this.dialogRef.close();
        const dialogRef = this.sidePanel.open(EnterPasscodeComponent);
        dialogRef.componentInstance.payload = payload;
        dialogRef.componentInstance.recipientInfo = this.recipientInfo;
        dialogRef.componentInstance.senderInfo = this.senderInfo;
    }

    protected cancel(): void {
        this.dialogRef.close();
    }
}
